<div class="row">
  <!-- BOX RESUMO DO PLANO -->
  <div class="col-lg-7 col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex w-100 justify-content-between">
          <div>
            <h2>
              <b>{{ planInfo.plan.name }}</b>
            </h2>
          </div>
          <div *ngIf="planInfo.qtdLicenses > 0; else onlyTax" class="price-summary">

            <div class="summary-line">
              <span class="label text-muted">Setup (incluso)</span>
              <span class="divider"></span>
              <span class="value">
                <b>R${{ 0 | number: "1.2-2" }}</b>
              </span>
            </div>

            <div class="summary-line">
              <span class="label text-muted">
                {{ getLicenseSummaryLabel() }}
              </span>
              <span class="divider"></span>
              <span class="value">
                <b>R${{ getValueLicenses() | number: "1.2-2" }}</b>
              </span>
            </div>

            <div class="summary-line" *ngIf="isDedicatedPlan()">
              <span class="label text-muted">
                Usuário root: {{ getRootUserLabel() }}
              </span>
              <span class="divider"></span>
              <span class="value">
                <b>Incluído</b>
              </span>
            </div>

            <div class="summary-line">
              <span class="label text-muted">Créditos de campanha</span>
              <span class="divider"></span>
              <span class="value">
                <b>R${{ planInfo.creditBalance || 0 | number: "1.2-2" }}</b>
              </span>
            </div>

          </div>
          <ng-template #onlyTax>
            <div class="summary-line">
              <span class="label text-muted">Taxa de ativação</span>
              <span class="divider"></span>
              <span class="value">
                <b>R${{ price | number: "1.2-2" }}</b>
              </span>
            </div>
          </ng-template>
        </div>
        <div
          style="font-size: 1.25rem"
          class="d-flex align-items-center justify-content-between mt-2"
        >
          <span>Total:</span>
          <span class="text-primary"><b>R${{ price | number: "1.2-2" }}</b></span>
        </div>
      </div>
    </div>
  </div>

  <!-- BOX CHECKOUT — idêntico ao checkout de campanha -->
  <div class="col-lg-5 col-12">
    <div class="containerCheckout">
      <div class="detailCheckout">
        <h6 class="titleCheckout">Pagamento</h6>

        <!-- Valor total do plano -->
        <div class="boxPrice">
          <div class="descriptionPrice">
            <i class="fa-solid fa-dollar-sign"></i>
            <p class="textPrice">Valor total</p>
          </div>
          <div class="tracejado"></div>
          <div class="valuePrice">R$ {{ price | number: "1.2-2" }}</div>
        </div>

        <!-- Saldo na carteira do agente + dedução -->
        <div class="boxPrice">
          <div class="descriptionPrice">
            <i class="fa-solid fa-wallet"></i>
            <p class="textPrice">Saldo na carteira ({{ getUserName() }})</p>
          </div>
          <div class="tracejado"></div>
          <div class="valuePrice" style="font-size: 13px; text-align: right; line-height: 1.5;">
            <span>R$ {{ walletBalance?.valueAvailable | number: "1.2-2" }}</span><br>
            <span class="green-pill" style="font-size: 11px;">- R$ {{ walletDeduction | number: "1.2-2" }}</span>
          </div>
        </div>

        <!-- Alerta: saldo insuficiente -->
        <div *ngIf="isWalletInsufficient" class="wallet-alert wallet-alert--danger">
          <i class="fa-solid fa-triangle-exclamation me-1"></i>
          Saldo insuficiente — faltam R$ {{ totalPrice | number: "1.2-2" }} para cobrir o plano.
        </div>

        <!-- Info: saldo cobre tudo, mostra o que sobra -->
        <div *ngIf="!isWalletInsufficient" class="wallet-alert wallet-alert--ok">
          <i class="fa-solid fa-circle-check me-1"></i>
          Saldo suficiente. Restará R$ {{ walletAfterPlan | number: "1.2-2" }} após a contratação.
        </div>

        <!-- Link para incluir crédito adicional (idêntico ao checkout de campanha) -->
        <a class="add-credit-link" *ngIf="!pixGenerated" (click)="toggleAddCreditInput()">
          <i class="fa-solid" [ngClass]="showAddCreditInput ? 'fa-minus' : 'fa-plus'"></i>
          {{ showAddCreditInput ? 'cancelar crédito adicional' : 'incluir crédito adicional carteira' }}
          <i class="fa-solid fa-circle-info ms-1"></i>
        </a>
        <div class="add-credit-input-box" *ngIf="showAddCreditInput && !pixGenerated">
          <label class="add-credit-label">Valor a adicionar (R$)</label>
          <div class="add-credit-field">
            <span class="add-credit-prefix">R$</span>
            <input
              class="add-credit-input"
              type="number"
              [(ngModel)]="additionalCredit"
              min="0"
              placeholder="0,00">
          </div>
        </div>
      </div>

      <!-- Total a pagar (só quando o saldo não cobre tudo) -->
      <div class="boxTotalPrice" *ngIf="totalPrice > 0">
        <p class="textPrice" style="margin-bottom: 8px;">Total a pagar</p>
        <h3 class="titleTotalPrice">R$ {{ totalPrice | number: "1.2-2" }}</h3>
      </div>

      <!-- Painel PIX/Fatura — só quando o saldo não cobre tudo.
           O valor exibido é o déficit (totalPrice), não o valor total do plano.
           Após a confirmação do PIX, o polling detecta e redireciona automaticamente. -->
      <rsm-pix-payment-display
        *ngIf="totalPrice > 0"
        [paymentMethod]="paymentMethod"
        [qrCode]="paymentReference"
        [isGenerating]="isGeneratingPix"
        [isGeneratingBoleto]="isGeneratingBoleto"
        [generated]="pixGenerated"
        [confirmed]="confirmed"
        [checking]="checking"
        [timedOut]="pollingTimedOut"
        [confirmedMessage]="'Plano contratado com sucesso! Redirecionando...'"
        [amount]="totalPrice"
        [dueDate]="dueDate"
        [boletoDescription]="'Contratação de plano'"
        [boletoDescriptionDetail]="planInfo?.plan?.name || ''"
        (methodChange)="selectPaymentMethod($event)"
        (generate)="requestPix()"
        (generateBoleto)="requestBoleto()"
        (downloadBoleto)="downloadBoleto()"
        (retry)="retryPix()"
        (copy)="copyCodeToClipboard()"
      ></rsm-pix-payment-display>

      <!-- Contratar plano — habilitado quando o saldo cobre tudo (totalPrice === 0).
           Quando há déficit e o usuário paga via PIX, a ativação é automática pelo
           polling, então este botão não é necessário naquele fluxo. -->
      <div class="d-flex flex-column align-items-center p-4">
        <button
          type="button"
          mat-raised-button
          [disabled]="totalPrice > 0 || confirmando || confirmed"
          (click)="requestHire()"
          class="buttonCheckout btn-green"
        >
          <ng-container *ngIf="!confirmando">
            <i class="fa-solid fa-check me-2"></i> Contratar plano
          </ng-container>
          <ng-container *ngIf="confirmando">
            <i class="fa-solid fa-spinner fa-spin me-2"></i> Contratando...
          </ng-container>
        </button>
        <small class="text-muted mt-2" *ngIf="totalPrice > 0" style="color: #a0aec0;">
          Conclua o pagamento para habilitar
        </small>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmação — antes de qualquer ação financeira -->
<modal-confirm #modalConfirmHire (onConfirm)="onConfirmAction($event)"></modal-confirm>
